"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { trimVideoOperation } from "../_operations/trimVideo";

export function TrimVideoContent() {
  return <MediaWorkspace operation={trimVideoOperation} />;
}
